export const SENTRY_RELEASE: string | undefined = 'c22f9aaf047844ad963eb1a5fc300b7b0d08adac';
